import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=22a62d32&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=22a62d32&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a62d32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22a62d32')) {
      api.createRecord('22a62d32', component.options)
    } else {
      api.reload('22a62d32', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=22a62d32&scoped=true", function () {
      api.rerender('22a62d32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/menuStoreTemplateManage/detail.vue"
export default component.exports